export default __webpack_public_path__ + "static/media/wa_6.e25011fc.mp3";